<template>
  <v-dialog v-model="visible" persistent max-width="100%">
    <v-card>
      <v-card-title class="text-uppercase">{{ titulo }}</v-card-title>

      <v-divider class="my-0"> </v-divider>

      <v-card-text class="pa-4">
        <v-row v-if="accion != accionesPresupuestoGestion.VERIFICAR && accion != accionesPresupuestoGestion.VER" dense>
          <v-col cols="12" md="4">
            <v-select
              :items="mesItems"
              label="Mes"
              v-model="form.mes"
              placeholder=" "
              outlined
              dense
              @input="validarMes"
              hide-details />
            <small v-for="error in errores.mes" :key="error" class="text-danger">{{ error }}</small>
          </v-col>

          <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" md="8"></v-col>

          <v-col cols="12" md="5">
            <vue-select
              v-model="agregarDetalle.clasificador_id"
              class="style-chooser"
              placeholder="Seleccione una Cuenta"
              label="nombre"
              :options="partidasItems"
              :selectable="(option) => !option.disabled && !option.esta_obsoleto">
              <template v-slot:option="option">
                <span v-html="option.descripcion_tabulada"></span>
              </template>
            </vue-select>
          </v-col>

          <v-col cols="12" md="4" v-if="tipo == tiposPresupuestos.GASTO">
            <v-select
              :items="departamentoUnidadItems"
              label="Unidad Gasto"
              v-model="agregarDetalle.unidad_gasto"
              placeholder=" "
              outlined
              dense
              hide-details />
          </v-col>

          <v-col cols="12" md="3" v-if="tipo == tiposPresupuestos.GASTO">
            <vue-select
              v-model="agregarDetalle.unidad"
              class="style-chooser"
              :clearable="false"
              placeholder="Seleccione Unidad Medida"
              label="descripcion"
              :options="unidadMedidaItems">
            </vue-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-text-field
              v-model="agregarDetalle.costo"
              label="Precio Unitario"
              type="number"
              placeholder=" "
              outlined
              dense
              min="0"
              hide-details></v-text-field>
          </v-col>

          <v-col cols="12" md="2">
            <v-text-field
              v-model="agregarDetalle.cantidad"
              label="Cantidad"
              type="number"
              placeholder=" "
              outlined
              dense
              min="0"
              hide-details></v-text-field>
          </v-col>

          <v-col cols="12" md="5">
            <v-text-field
              v-model="agregarDetalle.observaciones"
              label="Observaciones"
              placeholder=" "
              outlined
              dense
              hide-details></v-text-field>
          </v-col>

          <v-col cols="12" md="1">
            <v-btn color="primary" small @click.prevent="agregar"> Agregar </v-btn>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <v-btn
              v-if="accion == accionesPresupuestoGestion.VERIFICAR"
              :disabled="!selectedRows?.length"
              @click.prevent="$refs.modalEstablecerEstadoRef.abrir(selectedRows)">
              Establecer Estado
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ag-grid-vue
              :gridOptions="gridOptions"
              class="ag-theme-balham ag-grid-table-presupuesto-partida"
              :columnDefs="columnDefs"
              :defaultColDef="{ ...defaultColDef, floatingFilter: false }"
              @grid-ready="onGridReady"
              :rowData="form.detalles_transacciones"
              colResizeDefault="shift"
              :animateRows="true"
              :rowClassRules="rowClassRules"
              :pinnedBottomRowData="pinnedBottomRowData"
              @rowClicked="onRowClicked($event)"
              :alwaysShowVerticalScroll="true"
              :rowSelection="rowSelection"
              @first-data-rendered="onFirstDataRendered"
              @selection-changed="onSelectionChanged">
            </ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn v-if="accion != accionesPresupuestoGestion.VER" color="blue darken-1" text @click.prevent="validar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ModalEstablecerEstado ref="modalEstablecerEstadoRef" @establecer-estado="establecerEstado" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ClasificadorServices from '../services/clasificador';
import TransaccionServices from '../services/transaccion';
import UnidadMedidaServices from '../services/unidadMedida';
import {
  ACCIONES_CRUD,
  aMonedaValueFormatter,
  DEPARTAMENTOS_UNIDADES,
  ESTADOS_DETALLE_TRANSACCION,
  formatearErrores,
  formatearPartidas,
  formatearValorAMoneda,
  mapearTransaccion,
  MESES,
  TIPOS_PRESUPUESTOS,
} from '../utils';
import AgGridMixin from '../mixins/ag-grid-mixin';
import ModalEstablecerEstado from './ModalEstablecerEstado.vue';

export default {
  name: 'ModalFormPresupuestoGestionMes',
  mixins: [AgGridMixin],
  components: {
    ModalEstablecerEstado,
  },
  props: {
    tipo: {
      type: String,
      validator: (value) => {
        return Object.values(TIPOS_PRESUPUESTOS).includes(value);
      },
    },
  },
  data() {
    return {
      rowClassRules: {
        'row-aceptado': `data.estado == '${ESTADOS_DETALLE_TRANSACCION.ACEPTADO}'`,
        'row-rechazado': `data.estado == '${ESTADOS_DETALLE_TRANSACCION.RECHAZADO}'`,
      },
      agregarDetalle: this.establecerAgregarDetalle(),
      verificar: false,
      partida: null,
      partidasItems: [],
      visible: false,
      items: [],
      form: this.establecerTransaccion(),
      unidadMedidaItems: [],
      enviando: false,
      errores: [],
      accion: '',
      mesItems: MESES,
      departamentoUnidadItems: DEPARTAMENTOS_UNIDADES,
      accionesPresupuestoGestion: ACCIONES_CRUD,
      tiposPresupuestos: TIPOS_PRESUPUESTOS,
      estadosDetalleTransaccion: ESTADOS_DETALLE_TRANSACCION,
      selectedRows: null,
      columnDefsGasto: [
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 200,
        },
        {
          headerName: 'UNIDAD GASTO',
          field: 'unidad_gasto',
          filter: false,
          minWidth: 200,
          editable: true,
          singleClickEdit: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: () => {
            return { values: this.departamentoUnidadItems.map((unidad) => unidad.text) };
          },
        },
        {
          headerName: 'UNIDAD',
          field: 'unidad',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'PRECIO UNITARIO',
          field: 'costo',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          editable: (params) => {
            return params.node.rowPinned
              ? false
              : params.data.estado != this.estadosDetalleTransaccion.ACEPTADO
              ? true
              : false;
          },
          valueFormatter: aMonedaValueFormatter,
          valueParser: costoParser,
          singleClickEdit: true,
        },
        {
          headerName: 'CANTIDAD',
          field: 'cantidad',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
          editable: (params) => {
            return params.node.rowPinned
              ? false
              : params.data.estado != this.estadosDetalleTransaccion.ACEPTADO
              ? true
              : false;
          },
          valueFormatter: aMonedaValueFormatter,
          valueParser: cantidadParser,
          singleClickEdit: true,
        },
        {
          headerName: 'DEBE',
          field: 'debe',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
          valueGetter: (params) => {
            if (!params.node.rowPinned) {
              params.data.subtotal = params.data.cantidad * params.data.costo;
              params.data.debe =
                this.tipo === this.tiposPresupuestos.GASTO ? params.data.cantidad * params.data.costo : 0;

              return params.data.debe;
            }

            return params.node.data.debe;
          },
        },
        {
          headerName: 'HABER',
          field: 'haber',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
          valueGetter: (params) => {
            if (!params.node.rowPinned) {
              params.data.subtotal = params.data.cantidad * params.data.costo;
              params.data.haber =
                this.tipo === this.tiposPresupuestos.INGRESO ? params.data.cantidad * params.data.costo : 0;

              return params.data.haber;
            }

            return params.node.data.haber;
          },
        },
        {
          headerName: 'OBSERVACIONES',
          field: 'observaciones',
          filter: false,
          minWidth: 200,
          editable: (params) => {
            return params.node.rowPinned
              ? false
              : params.data.estado != this.estadosDetalleTransaccion.ACEPTADO
              ? true
              : false;
          },
          singleClickEdit: true,
        },
        {
          headerName: '',
          filter: false,
          minWidth: 50,
          maxWidth: 50,
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            } else if (params.data.estado != this.estadosDetalleTransaccion.ACEPTADO) {
              return /* html */ `
                <button type="button" data-action-type="remove" class="v-btn v-btn--icon v-btn--round theme--light pink--text">
                  <span class="v-btn__content">
                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-minus theme--light" data-action-type="remove"></i>
                  </span>
                </button>`;
            } else {
              return undefined;
            }
          },
        },
        {
          headerName: 'ESTADO',
          field: 'estado',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
      columnDefsIngreso: [
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 200,
        },
        {
          headerName: '',
          field: 'unidad_gasto',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: '',
          field: 'unidad',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'PRECIO UNITARIO',
          field: 'costo',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          editable: (params) => {
            return params.node.rowPinned ? false : params.data.remover;
          },
          valueFormatter: aMonedaValueFormatter,
          valueParser: costoParser,
          singleClickEdit: true,
        },
        {
          headerName: 'CANTIDAD',
          field: 'cantidad',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
          editable: (params) => {
            return params.node.rowPinned ? false : params.data.remover;
          },
          valueFormatter: aMonedaValueFormatter,
          valueParser: cantidadParser,
          singleClickEdit: true,
        },
        {
          headerName: 'DEBE',
          field: 'debe',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
          valueGetter: (params) => {
            if (!params.node.rowPinned) {
              params.data.subtotal = params.data.cantidad * params.data.costo;
              params.data.debe =
                this.tipo === this.tiposPresupuestos.GASTO ? params.data.cantidad * params.data.costo : 0;

              return params.data.debe;
            }

            return params.node.data.debe;
          },
        },
        {
          headerName: 'HABER',
          field: 'haber',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
          valueGetter: (params) => {
            if (!params.node.rowPinned) {
              params.data.subtotal = params.data.cantidad * params.data.costo;
              params.data.haber =
                this.tipo === this.tiposPresupuestos.INGRESO ? params.data.cantidad * params.data.costo : 0;

              return params.data.haber;
            }

            return params.node.data.haber;
          },
        },
        {
          headerName: 'OBSERVACIONES',
          field: 'observaciones',
          filter: false,
          minWidth: 200,
          editable: (params) => {
            return params.node.rowPinned ? false : true;
          },
          singleClickEdit: true,
        },
        {
          headerName: '',
          filter: false,
          minWidth: 50,
          maxWidth: 50,
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            } else if (params.data.remover) {
              return /* html */ `
                <button type="button" data-action-type="remove" class="v-btn v-btn--icon v-btn--round theme--light pink--text">
                  <span class="v-btn__content">
                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-minus theme--light" data-action-type="remove"></i>
                  </span>
                </button>
              `;
            } else {
              return undefined;
            }
          },
        },
        {
          headerName: 'ESTADO',
          field: 'estado',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
      columnDefsVerificarGasto: [
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 200,
        },
        {
          headerName: 'CUENTA CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'UNIDAD GASTO',
          field: 'unidad_gasto',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'UNIDAD',
          field: 'unidad',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'PRECIO UNITARIO',
          field: 'costo',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'CANTIDAD',
          field: 'cantidad',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'DEBE',
          field: 'debe',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'HABER',
          field: 'haber',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'OBSERVACIONES',
          field: 'observaciones',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'VERIFICAR',
          field: 'estado',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
          editable: true,
          singleClickEdit: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: {
            values: Object.keys(ESTADOS_DETALLE_TRANSACCION).map((key) => ESTADOS_DETALLE_TRANSACCION[key]),
          },
        },
      ],
      columnDefsVerificarIngreso: [
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 200,
        },
        {
          headerName: 'CUENTA CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: '',
          field: 'unidad_gasto',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: '',
          field: 'unidad',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'PRECIO UNITARIO',
          field: 'costo',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'CANTIDAD',
          field: 'cantidad',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'DEBE',
          field: 'debe',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'HABER',
          field: 'haber',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'OBSERVACIONES',
          field: 'observaciones',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'VERIFICAR',
          field: 'estado',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
          editable: true,
          singleClickEdit: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: {
            values: Object.keys(ESTADOS_DETALLE_TRANSACCION).map((key) => ESTADOS_DETALLE_TRANSACCION[key]),
          },
        },
      ],
      columnDefsVerGasto: [
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 200,
        },
        {
          headerName: 'CUENTA CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'UNIDAD GASTO',
          field: 'unidad_gasto',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'UNIDAD',
          field: 'unidad',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'PRECIO UNITARIO',
          field: 'costo',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'CANTIDAD',
          field: 'cantidad',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'DEBE',
          field: 'debe',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'HABER',
          field: 'haber',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'OBSERVACIONES',
          field: 'observaciones',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'ESTADO',
          field: 'estado',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
      ],
      columnDefsVerIngreso: [
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 200,
        },
        {
          headerName: 'CUENTA CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: '',
          field: 'unidad_gasto',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: '',
          field: 'unidad',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'PRECIO UNITARIO',
          field: 'costo',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'CANTIDAD',
          field: 'cantidad',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'DEBE',
          field: 'debe',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'HABER',
          field: 'haber',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'OBSERVACIONES',
          field: 'observaciones',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'ESTADO',
          field: 'estado',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
      ],
    };
  },
  computed: {
    pinnedBottomRowData() {
      return [
        {
          nombre: 'TOTALES',
          debe: this.tipo === this.tiposPresupuestos.GASTO ? this.calcularTotal() : '0,00',
          haber: this.tipo === this.tiposPresupuestos.INGRESO ? this.calcularTotal() : '0,00',
          bold: true,
        },
      ];
    },
    titulo() {
      let titulo = '';

      if (
        this.accion != this.accionesPresupuestoGestion.VERIFICAR &&
        this.accion != this.accionesPresupuestoGestion.VER
      ) {
        titulo = this.form.id
          ? `EDITAR REGISTRO ESTIMACIÓN PRESUPUESTARIO DE ${this.tipo} DE MES: ${this.form.mes}`
          : `REGISTRO ESTIMACIÓN PRESUPUESTARIO DE ${this.tipo} DE MES`;

        return titulo.toUpperCase();
      }

      titulo =
        this.accion == this.accionesPresupuestoGestion.VERIFICAR
          ? `APROBAR REGISTRO ESTIMACIÓN PRESUPUESTARIO DE ${this.tipo} DE MES: ${this.form.mes}`
          : `VER REGISTRO ESTIMACIÓN PRESUPUESTARIO DE ${this.tipo} DE MES`;

      return titulo.toUpperCase();
    },
    columnDefs() {
      return this.accion == this.accionesPresupuestoGestion.VERIFICAR
        ? this.tipo == this.tiposPresupuestos.GASTO
          ? this.columnDefsVerificarGasto
          : this.columnDefsVerificarIngreso
        : this.accion != this.accionesPresupuestoGestion.VER
        ? this.tipo == this.tiposPresupuestos.GASTO
          ? this.columnDefsGasto
          : this.columnDefsIngreso
        : this.tipo == this.tiposPresupuestos.GASTO
        ? this.columnDefsVerGasto
        : this.columnDefsVerIngreso;
    },
    rowSelection() {
      return this.accion == this.accionesPresupuestoGestion.VERIFICAR ? 'multiple' : 'single';
    },
  },
  created: function () {
    this.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        if (params.node.data.bold) {
          return { 'font-weight': 'bold' };
        }
      }
    };
  },
  watch: {
    'form.mes': function () {
      this.errores.mes = [];
    },
    columnDefs: {
      handler: function () {
        this.gridApi?.refreshCells();
      },
      deep: true,
    },
  },
  methods: {
    establecerTransaccion(presupuestoId) {
      return {
        id: null,
        presupuesto_id: presupuestoId ? presupuestoId : null,
        total: 0,
        mes: null,
        numero_mes: '',
        estado: ESTADOS_DETALLE_TRANSACCION.PENDIENTE,
        tipo: presupuestoId ? this.tipo : '',
        unidad_id: null,
        detalles_transacciones: [],
      };
    },
    establecerAgregarDetalle() {
      return {
        clasificador_id: null,
        nombre: '',
        costo: '',
        cantidad: '',
        observaciones: '',
        unidad: null,
        unidad_gasto: 'Administrativo, Contable y Finaciero',
      };
    },
    validarMes() {
      const meses = MESES.map((mes) => mes.value);

      this.form.numero_mes = meses.indexOf(this.form.mes) + 1;
    },
    calcularTotal() {
      let resultado = 0;

      for (let index = 0; index < this.form.detalles_transacciones.length; index++) {
        resultado = resultado + parseFloat(this.form.detalles_transacciones[index].subtotal);
      }

      this.form.total = resultado.toFixed(2);

      return formatearValorAMoneda(resultado);
    },
    abrir(accion, data = [], presupuesto_id) {
      this.accion = accion;
      this.unidadMedidaItems = [];
      this.partida = null;
      this.agregarDetalle = this.establecerAgregarDetalle();

      switch (accion) {
        case this.accionesPresupuestoGestion.REGISTRAR: {
          this.verificar = accion == this.accionesPresupuestoGestion.VERIFICAR;
          this.form = this.establecerTransaccion(presupuesto_id);
          this.visible = true;
          this.getPartidas();
          this.getUnidadesMedida();
          break;
        }
        case this.accionesPresupuestoGestion.EDITAR: {
          this.verificar = accion == this.accionesPresupuestoGestion.VERIFICAR;
          this.form = mapearTransaccion(data, presupuesto_id, accion);
          this.visible = true;
          this.getPartidas();
          this.getUnidadesMedida();
          break;
        }
        case this.accionesPresupuestoGestion.VERIFICAR: {
          this.verificar = accion == this.accionesPresupuestoGestion.VERIFICAR;
          this.form = mapearTransaccion(data, presupuesto_id, accion);
          this.visible = true;
          break;
        }
        case this.accionesPresupuestoGestion.VER: {
          this.verificar = accion == this.accionesPresupuestoGestion.VERIFICAR;
          this.form = mapearTransaccion(data, presupuesto_id, accion);
          this.visible = true;
          break;
        }
      }
    },
    cerrar() {
      this.visible = false;
      this.form = this.establecerTransaccion();
    },
    async getPartidas() {
      try {
        const response = await ClasificadorServices.getTipoPartida(
          `${this.tipo == this.tiposPresupuestos.GASTO ? 'Gastos' : 'Recursos'}`,
        );
        const partidas = response.data.datos;
        const partidasAplanadas = [];

        formatearPartidas(partidas, partidasAplanadas, '', 0);

        this.partidasItems = partidasAplanadas;
      } catch (err) {
        window.console.log(err);
      }
    },
    agregar() {
      const tipo = this.tipo === this.tiposPresupuestos.GASTO ? this.agregarDetalle.unidad : true;
      if (this.agregarDetalle.clasificador_id && this.agregarDetalle.costo && this.agregarDetalle.cantidad && tipo) {
        if (!(this.agregarDetalle.costo > 0 && this.agregarDetalle.cantidad > 0)) {
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: 'LOS VALORES DE CANTIDAD Y PRECIO UNITARIO DEBEN SER MAYORES A CERO',
            type: 'error',
          });

          return;
        }

        this.form.detalles_transacciones.push({
          clasificador_id: this.agregarDetalle.clasificador_id.id,
          clasificador: this.agregarDetalle.clasificador_id.nombre,
          nombre: this.agregarDetalle.nombre,
          costo: this.agregarDetalle.costo,
          unidad_gasto: this.tipo === this.tiposPresupuestos.GASTO ? this.agregarDetalle.unidad_gasto : '',
          cantidad: this.agregarDetalle.cantidad,
          observaciones: this.agregarDetalle.observaciones,
          unidad: this.agregarDetalle.unidad ? this.agregarDetalle.unidad.descripcion : '',
          unidad_medida_id: this.agregarDetalle.unidad ? this.agregarDetalle.unidad.id : null,
          subtotal: (parseFloat(this.agregarDetalle.costo) * parseFloat(this.agregarDetalle.cantidad)).toFixed(2),
          remover: 1,
          debe:
            this.tipo === this.tiposPresupuestos.GASTO
              ? (parseFloat(this.agregarDetalle.costo) * parseFloat(this.agregarDetalle.cantidad)).toFixed(2)
              : 0,
          haber:
            this.tipo === this.tiposPresupuestos.INGRESO
              ? (parseFloat(this.agregarDetalle.costo) * parseFloat(this.agregarDetalle.cantidad)).toFixed(2)
              : 0,
        });
        this.agregarDetalle = this.establecerAgregarDetalle();
        this.gridApi.refreshCells();
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'DEBE SELECCIONAR UNA CUENTA O LLENAR TODOS LOS CAMPOS',
          type: 'error',
        });
      }
    },
    onRowClicked(e) {
      if (e.event.target !== undefined) {
        let rowIndex = e.node.id;
        let actionType = e.event.target.getAttribute('data-action-type');
        switch (actionType) {
          case 'view':
          case 'remove':
            return this.remover(rowIndex);
        }
      }
    },
    remover(index) {
      this.form.detalles_transacciones.splice(index, 1);
    },
    validar() {
      if (this.form.detalles_transacciones.length > 0) {
        if (!this.enviando) {
          this.enviando = true;

          if (!this.verificar) {
            if (this.form.id) {
              this.operacion(this.accionesPresupuestoGestion.EDITAR);
            } else {
              this.operacion(this.accionesPresupuestoGestion.REGISTRAR);
            }
          } else {
            this.operacion(this.accionesPresupuestoGestion.VERIFICAR);
          }
        }
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'DEBE AGREGAR AL MENOS UNA CUENTA',
          type: 'error',
        });
      }
    },
    async operacion(accion) {
      this.enviando = true;

      try {
        let response = null;

        if (accion == this.accionesPresupuestoGestion.REGISTRAR) {
          response = await TransaccionServices.store(this.form);
        } else if (accion == this.accionesPresupuestoGestion.EDITAR) {
          response = await TransaccionServices.update(this.form.id, this.form);
        } else if (accion == this.accionesPresupuestoGestion.VERIFICAR) {
          response = await TransaccionServices.revisar(this.form.id, this.form);
        }

        const mensaje = response?.data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: this.titulo,
          text: mensaje,
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
        this.errores = [];
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores instanceof Object ? errores : [];
        this.$notify({
          group: 'notifications',
          title: mensaje,
          text: erroresFormateados,
          type: 'error',
        });
      } finally {
        this.enviando = false;
      }
    },
    async getUnidadesMedida() {
      try {
        const response = await UnidadMedidaServices.get();

        this.unidadMedidaItems = response.data.datos;
      } catch (err) {
        window.console.log(err);
      }
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
    },
    establecerEstado() {
      this.gridApi?.redrawRows();
    },
  },
};

function cantidadParser(params) {
  if (!isNaN(params.newValue) && params.newValue >= 0) {
    return Number(params.newValue).toFixed(2);
  } else {
    return params.data.cantidad;
  }
}

function costoParser(params) {
  if (!isNaN(params.newValue) && params.newValue >= 0) {
    return Number(params.newValue).toFixed(2);
  } else {
    return params.data.costo;
  }
}
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.v-dialog {
  align-items: flex-start;
}

.ag-grid-table-presupuesto-partida {
  height: calc(var(--vh, 1vh) * 100 - 24rem);
}
</style>

<style scoped>
hr {
  margin-top: 8px;
  margin-bottom: 10px;
  border: 0;
  border-top: 1px solid #eee;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .container,
.container-fluid {
  padding-right: 0px;
  padding-left: 0px;
}

::v-deep .container {
  width: 100%;
  padding: 0px;
  margin-right: auto;
  margin-left: auto;
}
</style>

<style>
.mood {
  border-radius: 15px;
  border: 1px solid grey;
  background: #e6e6e6;
  padding: 15px;
  text-align: center;
  display: inline-block;
  outline: none;
}

.default {
  border: 1px solid transparent !important;
  padding: 4px;
}

.selected {
  border: 1px solid lightgreen !important;
  padding: 4px;
}

.simple-input-editor {
  width: 100%;
  height: 100%;
}

.ag-theme-balham .row-aceptado {
  color: #309c51 !important;
}

.ag-theme-balham .row-rechazado {
  color: #c41111 !important;
}
</style>
